import { create } from "zustand";

// state cart sidebar open / close
export const useCartSidebarStore = create((set) => ({
  isOpen: false,
  open: () => {
    set({ isOpen: true });
  },
  close: () => {
    set({ isOpen: false });
  },
  toggle: () => {
    set((state) => {

      return { isOpen: !state.isOpen };
    });
  },
}));
